module.exports = __webpack_public_path__ + "static/media/twitter.3407b8d0.png";